// extracted by mini-css-extract-plugin
module.exports = {"root":"CompactList_root_IpfoB","item":"CompactList_item_2Zf4h","first":"CompactList_first_2zS-o","count":"CompactList_count_2VRzA","title":"CompactList_title_2H8JV"};